import { render, staticRenderFns } from "./PageBlocksWorkchainBlockTable.vue?vue&type=template&id=8be8f380"
import script from "./PageBlocksWorkchainBlockTable.vue?vue&type=script&lang=js"
export * from "./PageBlocksWorkchainBlockTable.vue?vue&type=script&lang=js"
import style0 from "./PageBlocksWorkchainBlockTable.vue?vue&type=style&index=0&id=8be8f380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports